import { EElectronicTradingType } from '../../../../JsonQuery/types/electronicTradingType';

export const ELECTRONIC_TRADING_TYPE_MAP_VALUE_TO_LABEL = {
  [EElectronicTradingType.DoNotDisplay]: 'Не показывать торги и залоговую недвижимость',
  [EElectronicTradingType.ElectronicTradingOnly]: 'Только торги и залоговая недвижимость',
};
